module.exports = __webpack_public_path__ + "img/eth_3d_ctfa27.2750525a.png";